export default "__VITE_ASSET__Dd_FYV_B__"